import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../constants';
import {
  AllocationActionPrepareCallToDockModel,
  AllocationDetailsModel,
  AllocationManualActionRequestModel,
  AllocationViewActionIdentifierModel,
  AllocationViewTimeslotOutputModel,
  CallToDockPrepareModel,
  CallToDockRequestModel,
} from '../../models';
import { map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AllocationViewCallToDockActionService {
  constructor(private http: WrapperHttpService) {}
  callToDockPrepare(
    actionIdentifier: AllocationViewActionIdentifierModel,
  ): Observable<AllocationActionPrepareCallToDockModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.CallToDock}${AllocationViewEndpoint.Prepare}`;

    return this.http
      .withLoading()
      .post<CallToDockPrepareModel>(url, actionIdentifier)
      .pipe(map((response: CallToDockPrepareModel) => new AllocationActionPrepareCallToDockModel(response)));
  }

  callToDock(body: CallToDockRequestModel): Observable<void> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.CallToDock}`;

    return this.http.withLoading().post<void>(url, body);
  }

  getAllocationDetails(identifier: AllocationViewActionIdentifierModel): Observable<AllocationDetailsModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Allocate}${AllocationViewEndpoint.Details}`;
    return this.http.withLoading().post<AllocationDetailsModel>(url, identifier);
  }

  allocateUli(body: AllocationManualActionRequestModel): Observable<AllocationViewTimeslotOutputModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Allocate}${AllocationViewEndpoint.Manual}`;
    return this.http.withLoading().post<AllocationViewTimeslotOutputModel>(url, body);
  }
}
